/* =========================================================================
   ClueVine — mode of the day
   A featured mode chosen deterministically from the date, so everyone sees the
   same one today and tomorrow's is reproducible. Picks only from the modes
   passed in, so it always respects the admin's enabled set.
   ========================================================================= */

import { createPrng } from './prng';
import type { AnyPuzzleMode } from './types';

export function modeOfTheDay(
  day: number,
  modes: readonly AnyPuzzleMode[],
): AnyPuzzleMode | null {
  if (modes.length === 0) return null;
  return createPrng(`cluevine:motd:${day}`).pick(modes);
}
